import i18n from '@/i18n';
export const formatLabels = (labels) => {
    const selectedLabels = Array.isArray(labels) ? labels : Object.values(labels);
    const hasMoreThanTwoSelections = selectedLabels.length > 2;
    const stringOr = i18n.global.t('or').toLowerCase();
    const stringOrAnother = i18n.global.t('or').toLowerCase() + ' ' + i18n.global.t('another');
    if (hasMoreThanTwoSelections) {
        const firstLabel = selectedLabels[0];
        const remainingCount = selectedLabels.length - 1;
        return `${firstLabel} ${stringOrAnother} ${remainingCount}`;
    }
    else {
        return selectedLabels.join(` ${stringOr} `);
    }
};
